import { handleResponse } from 'APIPackage/MainModule/common/handleResponse';
import { getServiceBaseURL } from 'APIPackage/MainModule/common/getServiceBaseURL';
import { APIServiceEnum } from 'APIPackage/MainModule/enums/APIServiceEnum';
import { apiMockSwitcher } from 'APIPackage/MainModule/mock/apiMockSwitcher';

import { INKOForeignAgent } from '../interfaces/INKOForeignAgent';

export async function fetchNKOForeignAgentByOgrn(ogrn: string): Promise<INKOForeignAgent> {
  const url = `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/catalogs/nko-foreign-agents/${ogrn}`;
  const mockData = apiMockSwitcher<INKOForeignAgent>(url, 'GET');

  if (mockData) return mockData;

  return fetch(url, {
    method: 'GET',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
  }).then(handleResponse);
}
